'use strict';

import {debounce} from './../../../../build/node_modules/@components/throttle-debounce';

const $ = require('jquery');

class AutoComplete {

    constructor() {

        this.$autocomplete = $('[data-autocomplete]');
        this.$autocompleteInput = this.$autocomplete.find('input');
        this.$autocompleteList = this.$autocomplete.find('ul');
        this.keyword = '';
        this.activeClassName = 'search-active';
        this.noResultText = this.$autocomplete.data('autocomplete-no-results');
        this.autocompleteCache = {};

        this.autoCompleteHandler();
        this.closeOverlayHandler();
        this.formButtonHandler();
    }

    autoCompleteHandler() {

        this.$autocompleteInput.on('keyup', debounce(150, (event) => {

            this.keyword = event.target.value;

            //  check if keyword has more than 3 characters
            if (this.keyword.length <= 2) {

                this.reset();
                return
            }

            //  Ajax handling the input value
            this.fetchData();
        }));
    }

    closeOverlayHandler() {

        $('.search-overlay').on('click', (event) => {

            event.preventDefault();

            this.$autocompleteInput.val('');
            this.reset();
        });
    }

    formButtonHandler() {

        this.$autocomplete.find('button').on('click', (event) => {

            if (this.keyword.length <= 2) {

                event.preventDefault();
            }
        });
    }

    fetchData() {

        const cached = this.autocompleteCache[this.keyword];

        if (cached) {

            this.render(cached);
        } else {

            $.ajax({
                url: `/api/search_autocomplete/${this.keyword}/`,
                dataType: 'json'
            }).done((data) => {

                this.autocompleteCache[this.keyword] = data;
                this.render(data);
            });
        }
    }

    render(data) {

        //  Reset all
        this.reset();

        //  Activate box
        App.Globals.body.classList.add(this.activeClassName);

        if (data.suggestions.length > 0) {

            //  Loop through data and make list
            for (let i = 0; i < data.suggestions.length; i++) {

                let item = data.suggestions[i];

                if (item.post_type === 'download') {
                    if (typeof item.custom.file_url !== 'undefined') {
                        let bytes = item.custom.file_url.filesize;
                        let kiloBytes = (bytes / 1024).toFixed(0);
                        let megaBytes = (kiloBytes / 1024).toFixed(1);
                        let size = '';
                        if (bytes > 1048576) {
                            size = megaBytes + ' MB';
                        } else {
                            size = kiloBytes + ' KB'
                        }

                        this.$autocompleteList.append(`
                            <li>
                                <a href="${item.custom.file_url.url}">
                                    <h5>${item.post_title}</h5>
                                    <p>${item.post_type_labels.singular_name} (${size})</p>
                                </a>
                            </li>
                        `);
                    }
                } else {
                    this.$autocompleteList.append(`<li><a href="${item.link}"><h5>${item.post_title}</h5><p>${item.post_excerpt}</p></a></li>`);
                }
            }

        } else {

            //  No results
            this.$autocompleteList.append(`<li class="no-results">${this.noResultText}</li>`);
        }
    }

    reset() {

        //  Remove old results
        this.$autocompleteList.html('');

        //  Remove active classname
        App.Globals.body.classList.remove(this.activeClassName);
    }
}

module.exports = AutoComplete;
